// extracted by mini-css-extract-plugin
module.exports = {"panel":"e_4Q","pop-in":"e_5Q"};